//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Page404',
  computed: {
    message: function message() {
      return '您没有访问该地址的权限...';
    }
  }
};